// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"425":"5bfafcd3","750":"c833e9d1"}[chunkId] + ".chunk.js");